import { useEffect } from 'react';
import { createStore } from 'zustand/vanilla';
import { EnumValue } from '@mews/enumify';
import { TRANSLATION_NOT_FOUND, useLocalizeEnum, useLocalizeText } from '@mews/framework';

interface LegacyLocalizationStore {
    localizeText: ReturnType<typeof useLocalizeText>;
    localizeEnum: ReturnType<typeof useLocalizeEnum>;
}

const legacyLocalizationStore = createStore<LegacyLocalizationStore | null>(() => null);

export const useLegacyLocalization = () => {
    const localizeText = useLocalizeText();
    const localizeEnum = useLocalizeEnum();

    useEffect(() => {
        legacyLocalizationStore.setState({ localizeText, localizeEnum });
    }, [localizeText, localizeEnum]);
};

export const isLegacyLocalizationInitialized = () => legacyLocalizationStore.getState() != null;

/** @internal */
export const localizeText__DO_NOT_USE: ReturnType<typeof useLocalizeText> = (props) => {
    const lt = legacyLocalizationStore.getState()?.localizeText;
    if (!lt) {
        throw new Error('Legacy localization is not set');
    }
    return lt(props);
};

/** @internal */
export const localizeEnum__DO_NOT_USE: ReturnType<typeof useLocalizeEnum> = (prefix, value) => {
    const le = legacyLocalizationStore.getState()?.localizeEnum;
    if (!le) {
        throw new Error('Legacy localization is not set');
    }
    return le(prefix, value);
};

/** @internal */
export const localizeEnumify__DO_NOT_USE = (enumValue: EnumValue) => {
    const translationWithPrefix = localizeText__DO_NOT_USE({
        textKey: enumValue.toString() as Mews.TextKey,
        fallbackToKey: false,
    });

    return translationWithPrefix !== TRANSLATION_NOT_FOUND
        ? translationWithPrefix
        : localizeText__DO_NOT_USE({ textKey: enumValue.name as Mews.TextKey });
};
